/**
 * While picking a battlefield target (deploy shield, weapon, strategem, etc.),
 * expanded OrderDesign portals must not capture clicks — they would hit the wrong unit.
 *
 * @param {object} ctx - Flags from BattleUI (same shape as destructured below).
 * @returns {boolean}
 */
export function passThroughExpandedBattlefieldPortalsForTargeting(ctx) {
  const {
    deployTargetMode,
    selectedDeployOrderId,
    strategemTargetMode,
    selectedStrategemId,
    weaponTargetMode,
    selectedWeaponId,
    confuseTargetMode,
    selectedConfuseWeaponId,
    immobilizeTargetMode,
    selectedImmobilizeWeaponId,
    droneTargetMode,
    selectedDroneId,
    weaponDeployTargetMode,
    weaponDeployTargetInfo,
    replaceTargetMode,
    selectedReplaceUnitId,
    replaceDroneTargetMode,
    selectedReplaceDroneId,
    effectiveAttackMode,
    specialTargetMode,
    selectedSpecialUnitId,
  } = ctx;
  if (deployTargetMode && selectedDeployOrderId) return true;
  if (strategemTargetMode && selectedStrategemId) return true;
  if (weaponTargetMode && selectedWeaponId) return true;
  if (confuseTargetMode && selectedConfuseWeaponId) return true;
  if (immobilizeTargetMode && selectedImmobilizeWeaponId) return true;
  if (droneTargetMode && selectedDroneId) return true;
  if (weaponDeployTargetMode && weaponDeployTargetInfo) return true;
  if (replaceTargetMode && selectedReplaceUnitId) return true;
  if (replaceDroneTargetMode && selectedReplaceDroneId) return true;
  if (effectiveAttackMode) return true;
  if (specialTargetMode && selectedSpecialUnitId) return true;
  return false;
}
